import { BlogFAQItem } from '@/models/blog-post';
import { MaterialTextField } from '@/shared/components/form/MaterialFormElements';
import { addButtonStyle, dangerButtonStyle } from '@/shared/dark-inline-styles';

interface FaqEditorProps {
    faq: BlogFAQItem[];
    onChange: (faq: BlogFAQItem[]) => void;
}

/**
 * Small repeatable Q/A list. Each non-empty pair becomes a FAQPage JSON-LD
 * entry on the live post (rich "People also ask"-style results in Google).
 */
const FaqEditor = ({ faq, onChange }: FaqEditorProps) => {
    const update = (index: number, patch: Partial<BlogFAQItem>) => {
        onChange(faq.map((item, i) => (i === index ? { ...item, ...patch } : item)));
    };
    const remove = (index: number) => onChange(faq.filter((_, i) => i !== index));
    const add = () => onChange([...faq, { q: '', a: '' }]);

    return (
        <div>
            <p style={{ marginBottom: 4, fontWeight: 600 }}>FAQ (optional)</p>
            <p style={{ marginBottom: 10, fontSize: 12, color: '#999999' }}>
                Add 2–5 common questions. These render on the post AND emit FAQ structured data, which can appear as rich results in Google.
            </p>
            {faq.map((item, i) => (
                <div key={i} style={{ border: '1px solid #e6e6e6', borderRadius: 6, padding: 12, marginBottom: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                        <span style={{ fontSize: 12, color: '#999' }}>Question {i + 1}</span>
                        <button type="button" onClick={() => remove(i)} style={{ ...dangerButtonStyle, fontSize: 12 }}>
                            Remove
                        </button>
                    </div>
                    <MaterialTextField label="Question" value={item.q} onChange={(e) => update(i, { q: e.target.value })} />
                    <MaterialTextField label="Answer" multiline value={item.a} onChange={(e) => update(i, { a: e.target.value })} />
                </div>
            ))}
            <button type="button" onClick={add} style={{ ...addButtonStyle, borderRadius: 6, padding: '8px 14px' }}>
                + Add question
            </button>
        </div>
    );
};

export default FaqEditor;
